import { isArrayWithValue } from '@/utils/helpers/isArrayWithValue';
import { IStoryPage } from '@/utils/interfaces/stories';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import { useRouter } from 'next/router';
import { Fragment, useEffect } from 'react';
import { StoryAlternatesHrefLang } from '../Shared/StoryAlternatesHrefLang';
import { SEO } from '@/components/Shared/SEO';
import { removeLocale } from '@/utils/helpers/removeLocale';
import { Footer } from '@/components/Shared/Layout/Footer/Footer';
import { Header } from '../Shared/Layout/Header';

interface IProps {
	blok: IStoryPage;
	story: any;
	preview: boolean;
}
export const Page: React.FC<IProps> = ({ blok, preview, story }) => {
	const { locale, asPath } = useRouter();
	const path = removeLocale(asPath);
  useEffect(() => {
    const shouldInject = asPath.startsWith('/public-portal');
    if (!shouldInject) return;
    const injectWidgetScript = () => {
      if (document.querySelector('script[src*="widget.canibuild.com/embed.js"]')) return;
      const script = document.createElement('script');
      script.src = 'https://widget.canibuild.com/embed.js?id=lc-widget&token=a9c1f4d9-e4b2-4d26-8b11-a03edcb68458';
      script.defer = true;
      document.body.appendChild(script);
    };
    if (document.readyState === 'complete') {
      setTimeout(injectWidgetScript, 1000);
    } else {
      const onLoad = () => setTimeout(injectWidgetScript, 1000);
      window.addEventListener('load', onLoad);
      return () => window.removeEventListener('load', onLoad);
    }
  }, [asPath]);  
  return (
    <Fragment>
      <StoryAlternatesHrefLang locale={locale} asPath={path} story={story} />
      <SEO
        name={story.name}
        seo={blok.seo}
        og_type="website"
        asPath={path}
        locale={locale}
      />
      <Header />
      <main {...storyblokEditable(blok)}>
        {isArrayWithValue(blok.body) &&
          blok.body.map((nestedBlok: any) => (
            <StoryblokComponent
              blok={nestedBlok}
              preview={preview}
              key={nestedBlok._uid}
            />
          ))}
{asPath.startsWith('/public-portal') && (
  <div className="flex justify-center items-center w-full bg-white h-[850px]">
    <div id="lc-widget" className="w-full h-[850px]" />
  </div>
)}
      </main>
      {!blok.hide_footer && <Footer />}
		</Fragment>
	);
};
